
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[alias]",
      function () {
        return require("private-next-pages/[alias].js");
      }
    ]);
  